import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drip from 'drip';
import KNB from '@dp/knb';
import { submitRemindDetailNew } from '@/request/detail-new/index';
export default {
  props: {
    show: Boolean,
    numberValue: String,
    canSubmit: Boolean,
    isShowPrice: Boolean,
    priceList: Array,
    isShowReminderPublic: {
      // 预约公示情况下的缺货登记文案有所不同
      type: Boolean,
      default: false
    },
    performanceId: Number,
    remindeSource: Boolean,
    bindMobile: String
  },
  data: function data() {
    return {
      // bindMobile: '',
      // reminderPublicModalSource: '',
    };
  },
  computed: {},
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            /**
             * 之前代码在点击预约时，直接打开本组件（预约弹窗），在组件生命周期里请求接口，接口失败又关掉弹窗，操作有些迷惑；
             * 本次把逻辑修改到外面，成功才打开弹窗，暂保留代码观察下有什么问题。
             */

            // 没价格开售提醒 直接提交
            // if ( !this.isShowPrice ) {
            //   try {
            //     if ( !Drip.User.isLogin ) await Drip.login()
            //     let { code, data, msg, attrMaps: { mobile = this.numberValue } } = await this.remindRequest()
            //     if ( code === 200 && data ) {
            //       this.bindMobile = mobile
            //       this.reminderPublicModalSource = data
            //     } else {
            //       this.$toast( msg )
            //     }
            //   } catch ( error ) {
            //     this.$emit( 'hide' )
            //     this.$toast( '小喵没记住手机号，请再试一下' )
            //   }
            // }
            _this.modalViewStats();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {
    document.body.style.overflow = 'hidden';
  },
  methods: {
    remindMeSubmitStats: function remindMeSubmitStats(attrMaps) {
      if (attrMaps.userId && Drip.UA.IS_QQWALLET) {
        window.Analytics('use', 'movie', {
          uid: attrMaps.userId || 0
        });
        var options = {
          phonenumber: this.bindMobile,
          performanc_id: this.performanceId
        };
        window.seedAction({
          bid: 'b_id5bevfv',
          evt: 'click',
          custom: Object.assign({}, options, {
            custom: Object.assign({}, options)
          })
        });
      }
    },
    touchmove: function touchmove(event) {
      if (!this.isShowPrice) {
        event.preventDefault();
      }
      // event.stopPropagation()
    },

    boxClick: function boxClick(event) {
      event.preventDefault();
    },
    hide: function hide() {
      this.$emit('hide');
    },
    onEnter: function onEnter(e) {
      var value = e.target.value;
      this.$emit('inputChange', value);
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!_this2.canSubmit) {
                _context2.next = 5;
                break;
              }
              _context2.next = 3;
              return _this2.remindRequest();
            case 3:
              res = _context2.sent;
              _this2.$emit('submit', res);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    selected: function selected(id) {
      this.$emit('selected', id);
    },
    remindRequest: function remindRequest() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var numberValue, performanceId, isShowPrice, priceList, params, selectedPrice;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              numberValue = _this3.numberValue, performanceId = _this3.performanceId, isShowPrice = _this3.isShowPrice, priceList = _this3.priceList;
              params = {
                projectId: performanceId
              };
              if (isShowPrice && priceList.length > 0) {
                // 有票档
                selectedPrice = priceList.filter(function (item) {
                  return !!item.selected;
                });
                selectedPrice = selectedPrice.map(function (item) {
                  var newItem = Object.assign({}, item);
                  delete newItem.selected;
                  return newItem;
                });

                // newParams.ticketPriceList = selectedPrice
              }

              _context3.prev = 3;
              _context3.next = 6;
              return submitRemindDetailNew(params);
            case 6:
              return _context3.abrupt("return", _context3.sent);
            case 9:
              _context3.prev = 9;
              _context3.t0 = _context3["catch"](3);
              // 发生错误，错误处理
              // console.log( error ) // todo: 错误处理
              _this3.$toast(_this3.$ERROR_TEXT);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[3, 9]]);
      }))();
    },
    shut: function shut() {
      this.$emit('submit', {
        data: this.remindeSource,
        attrMaps: {
          mobile: this.bindMobile
        }
      });
      this.hide();
      this.knowClickStats();
    },
    knowClickStats: function knowClickStats() {
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_fypp9bfd_mc',
        cid: 'c_Q7wY4'
      });
    },
    modalViewStats: function modalViewStats() {
      window.seedAction({
        bid: 'b_movie_f8ppk3wz_mv',
        evt: 'view',
        cid: 'c_Q7wY4'
      });
    }
  },
  directives: {
    focus: {
      inserted: function inserted(el) {
        el.focus();
      }
    }
  },
  destroyed: function destroyed() {
    document.body.style.overflow = 'initial';
  }
};